import "./AvailableProperties.css";

export default function AvailableProperties() {
  const properties = [
    {
      id: 1,
      title: "MANSORY RESIDENCES BY AMAAL",
      location: "Meydan Horizon",
      commission: "7%",
      paymentPlan: "50% during construction / 50% on handover",
      handover: "Q4 2028",
      towers: [
        {
          name: "AMAAL 8 – SOUTH TOWER",
          units: [
            {
              type: "1 Bedroom",
              priceRange: "From AED 1.84M up to AED 2.25M"
            },
            {
              type: "2 Bedroom",
              priceRange: "From AED 3.00M up to AED 3.97M"
            },
            {
              type: "3 Bedroom",
              priceRange: "From AED 4.09M up to AED 4.14M"
            }
          ]
        },
        {
          name: "MANSORY RESIDENCES – NORTH TOWER",
          units: [
            {
              type: "1 Bedroom",
              priceRange: "From AED 2.39M up to AED 2.86M"
            },
            {
              type: "2 Bedroom",
              priceRange: "From AED 3.14M up to AED 4.93M"
            },
            {
              type: "3 Bedroom",
              priceRange: "From AED 4.83M up to AED 8.61M"
            },
            {
              type: "4 Bedroom Duplex",
              priceRange: "From AED 12.15M up to AED 12.19M"
            }
          ]
        }
      ]
    }
  ];

  const ellingtonProperties = [
    {
      id: 1,
      name: "The Hillgate",
      location: "Dubai Silicon Oasis",
      units: "2 & 3BR apartments",
      startingPrice: "AED 1.94M",
      highlights: "Excellent value & strong rental demand",
      paymentPlan: "70/30"
    },
    {
      id: 2,
      name: "Riverton House",
      location: "Meydan Horizon",
      units: "1 & 2BR residences",
      startingPrice: "AED 2.17M",
      highlights: "Prime future growth location",
      paymentPlan: "70/30"
    },
    {
      id: 3,
      name: "Belgravia Gardens",
      location: "Dubailand",
      units: "Spacious 2 & 3BR homes",
      startingPrice: "AED 2.45M",
      highlights: "Family-oriented community",
      paymentPlan: "70/30"
    },
    {
      id: 4,
      name: "One River Point & The Crestmark",
      location: "Business Bay",
      units: "1–4BR units",
      startingPrice: "AED 3.06M",
      highlights: "Canal views & central location",
      paymentPlan: "70/30"
    },
    {
      id: 5,
      name: "Ocean House",
      location: "Palm Jumeirah",
      units: "Ultra-luxury 2 & 4BR residences",
      startingPrice: "AED 22.6M",
      highlights: "Iconic beachfront living",
      paymentPlan: "60/40"
    },
    {
      id: 6,
      name: "Playa Del Sol",
      location: "Ras Al Khaimah",
      units: "2 & 3BR beachfront homes",
      startingPrice: "AED 3.8M",
      highlights: "High holiday-rental potential",
      paymentPlan: "60/40"
    }
  ];

  return (
    <div className="available-properties">
      <div className="container">
        <h1 className="page-title">Available Properties</h1>

        {/* Ellington Properties Section - Now First */}
        <section className="ellington-section">
          <h2 className="section-title">Ellington Properties</h2>
          <p className="section-subtitle">Availability Summary - 06 January 2026</p>

          <div className="properties-list">
            {ellingtonProperties.map((property) => (
              <div key={property.id} className="property-item">
                <h3 className="property-name">{property.name}</h3>
                <p className="location">{property.location}</p>
                
                <div className="property-info">
                  <div className="info-row">
                    <span className="info-label">Units:</span>
                    <span className="info-value">{property.units}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Starting from:</span>
                    <span className="info-value price">{property.startingPrice}</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Payment Plan:</span>
                    <span className="info-value">{property.paymentPlan}</span>
                  </div>
                </div>

                <p className="highlights">{property.highlights}</p>
              </div>
            ))}
          </div>

          <div className="why-ellington">
            <h3>Why Ellington?</h3>
            <ul>
              <li>Premium design & finishes</li>
              <li>Strong end-user & investment appeal</li>
              <li>Limited availability across projects</li>
            </ul>
            <p className="cta-text">
              Let us know your budget, preferred location, or unit size, and we'll shortlist the best options for you
            </p>
          </div>
        </section>

        {/* Mansory Residences Section - Now Second */}
        <section className="featured-property">
          {properties.map((property) => (
            <div key={property.id} className="property-card">
              <div className="property-header">
                <h2 className="property-title">{property.title}</h2>
                <p className="property-location">{property.location}</p>
              </div>

              <div className="property-details">
                <div className="detail-item">
                  <span className="label">Commission:</span>
                  <span className="value">{property.commission}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Payment Plan:</span>
                  <span className="value">{property.paymentPlan}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Handover:</span>
                  <span className="value">{property.handover}</span>
                </div>
              </div>

              <div className="towers-grid">
                {property.towers.map((tower, index) => (
                  <div key={index} className="tower-card">
                    <h3 className="tower-name">{tower.name}</h3>
                    <div className="units-list">
                      {tower.units.map((unit, unitIndex) => (
                        <div key={unitIndex} className="unit-item">
                          <span className="unit-type">{unit.type}</span>
                          <span className="unit-price">{unit.priceRange}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <p className="contact-message">
                Happy selling — exciting opportunities await. Contact us for full details
              </p>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
